import { render, staticRenderFns } from "./TopNav.vue?vue&type=template&id=8755c148&scoped=true&"
import script from "./TopNav.vue?vue&type=script&lang=js&"
export * from "./TopNav.vue?vue&type=script&lang=js&"
import style0 from "./TopNav.vue?vue&type=style&index=0&id=8755c148&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8755c148",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Announcements: require('/Users/grant/Dev/postpone/frontend/components/Announcements.vue').default})
